/**
 * Notion URL から notionID を抽出する
 * 例: https://www.notion.so/ページ名-abc123def456 → abc123def456
 */
export const extractNotionIdFromUrl = (url: string): string | null => {
	try {
		const urlObj = new URL(url);
		const hostname = urlObj.hostname.toLowerCase();
		const isNotionHost =
			hostname === "chillnn.notion.site" ||
			hostname === "notion.so" ||
			hostname === "www.notion.so" ||
			hostname.endsWith(".notion.so");
		// notion.so または www.notion.so のドメインかチェック
		if (!isNotionHost) {
			return null;
		}
		// パスの最後の部分を取得（例: ページ名-abc123def456）
		const pathParts = urlObj.pathname.split("/").filter(Boolean);
		const lastPart = pathParts[pathParts.length - 1];
		if (!lastPart) return null;

		// 最後のハイフン以降がIDの場合（32文字の16進数）
		const match = lastPart.match(/-([a-f0-9]{32})$/i);
		if (match) {
			return match[1];
		}

		// パス全体が32文字の16進数の場合
		if (/^[a-f0-9]{32}$/i.test(lastPart)) {
			return lastPart;
		}

		return null;
	} catch {
		return null;
	}
};
